import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router";
import { useStaticQuery, graphql } from "gatsby";
import SeoType from "../types/seo.type";
import SmartBanner from "./SmartBanner";
import SurpriseBonusPopUp from "./SurpriseBonusPopUp";

const SEO = ({
  data,
  scripts,
  shouldShowBanner,
  setShouldShowBanner,
  isLpPage,
  smartBannerLink,
  impressionLink,
}: SeoType) => {
  const { pathname } = useLocation();
  const { site } = useStaticQuery(query);
  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    defaultImage,
    twitterUsername,
  } = site.siteMetadata;

  const seo = {
    title: data.title || defaultTitle,
    description: data.description || defaultDescription,
    image: data.socialImage?.url || `${siteUrl}${defaultImage}`,
    url: `${siteUrl}${pathname}`,
  };

  const selfUrl = typeof window !== "undefined" ? window.location.href : "";

  const noFollow = data["no_follow"] ? true : false;
  const noIndex = data["no_index"] ? true : false;
  const follow = data["follow"] ? true : false;
  // const excludedSurpriseBonusPopUp = ["/", "/free-coins/"]

  const schemaOrgs = site?.siteMetadata?.schemaOrgs?.map((item) => ({
    ...item,
    "@context": item._context,
    "@type": item._type,
  }));

  return (
    <>
      {/* <script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/1044a885-e25b-4562-9af0-cb0133fbf462/OtAutoBlock.js"
      /> */}
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="1044a885-e25b-4562-9af0-cb0133fbf462"
        data-ot-ignore
      />
      <script data-ot-ignore>
        {`
            function OptanonWrapper() { }
          `}
      </script>
      {/* {!isLpPage &&
        !excludedSurpriseBonusPopUp.find((item) => pathname === item) && (
          <SurpriseBonusPopUp />
        )} */}
      {!!impressionLink && (
        <img className="hidden" src={impressionLink} alt="impression-Link" />
      )}
      <SmartBanner
        shouldShowBanner={shouldShowBanner}
        setShouldShowBanner={setShouldShowBanner}
        ctaLink={smartBannerLink}
      />
      <Helmet
        htmlAttributes={{ lang: "en" }}
        title={seo.title}
        titleTemplate={titleTemplate}
      >
        <script key="GTM" data-ot-ignore>
          {`
            !(function (e, t, a, n, g) {
              (e[n] = e[n] || []),
                e[n].push({
                  "gtm.start": new Date().getTime(),
                  event: "gtm.js",
                });
              var m = t.getElementsByTagName(a)[0],
                r = t.createElement(a);
              (r.async = !0),
                (r.src =
                  "https://www.googletagmanager.com/gtm.js?id=GTM-TCDBRN2"),
                m.parentNode.insertBefore(r, m);
            })(window, document, "script", "dataLayer")
          `}
        </script>
        <script type="text/javascript" id="vwoCode" key="vwoCode" data-ot-ignore>
          {`
             window._vwo_code=window._vwo_code || (function() {
                var account_id=692621,
                version = 1.5,
                settings_tolerance=2000,
                library_tolerance=2500,
                use_existing_jquery=false,
                is_spa=1,
                hide_element='body',
                hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
                /* DO NOT EDIT BELOW THIS LINE */
                f=false,d=document,vwoCodeEl=d.querySelector('#vwoCode'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return'{'+hide_element_style+'}'},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement('script');t.fetchPriority='high';t.src=e;t.type='text/javascript';t.innerText;t.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)\s?(_vis_opt_exp_\d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_\d+_combi=(?:\d+,?)+\s*$/.test(t)){return''}return t}catch(e){return''}});var i=[];e.forEach(function(e){var t=e.match(/([\d,]+)/g);t&&i.push(t.join('-'))});return i.join('|')},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;window.settings_timer=setTimeout(function(){_vwo_code.finish()},settings_tolerance);var e=d.createElement('style'),t=hide_element?hide_element+'{'+hide_element_style+'}':'',i=d.getElementsByTagName('head')[0];e.setAttribute('id','_vis_opt_path_hides');vwoCodeEl&&e.setAttribute('nonce',vwoCodeEl.nonce);e.setAttribute('type','text/css');if(e.styleSheet)e.styleSheet.cssText=t;else e.appendChild(d.createTextNode(t));i.appendChild(e);var n=this.getCombinationCookie();this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+ +is_spa+'&vn='+version+(n?'&c='+n:''));return settings_timer}};window._vwo_settings_timer = code.init();return code;}())
          `}
        </script>
        <noscript key="GTM-iframe">
          {`
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-TCDBRN2"
              height="0"
              width="0"
              style="display:none;visibility:hidden"
            ></iframe>
          `}
        </noscript>
        <meta name="description" content={seo.description} />
        <meta name="image" content={seo.image} />
        <link
          rel="canonical"
          href={data.canonical ? data.canonical : selfUrl}
        />
        {noIndex && !noFollow && !follow && (
          <meta name="robots" content="noindex" />
        )}
        {noIndex && follow && <meta name="robots" content="noindex, follow" />}
        {noIndex && noFollow && (
          <meta name="robots" content="noindex, nofollow" />
        )}
        {!noIndex && noFollow && <meta name="robots" content="nofollow" />}
        {seo.url && <meta property="og:url" content={seo.url} />}
        {seo.title && <meta property="og:title" content={seo.title} />}
        {seo.description && (
          <meta property="og:description" content={seo.description} />
        )}
        {seo.image && <meta property="og:image" content={seo.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        {twitterUsername && (
          <meta name="twitter:creator" content={twitterUsername} />
        )}
        {seo.title && <meta name="twitter:title" content={seo.title} />}
        {seo.description && (
          <meta name="twitter:description" content={seo.description} />
        )}
        {seo.image && <meta name="twitter:image" content={seo.image} />}
        {data.schemaJson && (
          <script key="schemaJson" type="application/ld+json" data-ot-ignore>
            {data.schemaJson.schemaJson}
          </script>
        )}
        {schemaOrgs &&
          schemaOrgs.map((schema) => (
            <script key="schemaOrgs" type="application/ld+json" data-ot-ignore>
              {JSON.stringify(schema)}
            </script>
          ))}
        {data.additionalSchemaJson && (
          <script
            id="additionalSchemaJson"
            key="additionalSchemaJson"
            type="application/ld+json"
            data-ot-ignore
          >
            {data.additionalSchemaJson.additionalSchemaJson}
          </script>
        )}
        {scripts &&
          scripts.map((script, index) => (
            <script key={`script_${index}`} data-ot-ignore>{script}</script>
          ))}
        {isLpPage && (
          <script
            async
            key="gtag"
            src="https://www.googletagmanager.com/gtag/js?id=AW-942274225"
            data-ot-ignore
          />
        )}
        {isLpPage && (
          <script key="isLpPage" data-ot-ignore>
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-942274225');
          `}
          </script>
        )}
        {isLpPage && (
          <script key="isLpPage_scripts" data-ot-ignore>
            {`
            function gtag_report_conversion(url) {
              var callback = function () {
                if (typeof(url) != 'undefined') {
                  window.location = url;
                }
              };
              gtag('event', 'conversion', {
                  'send_to': 'AW-942274225/i4OmCMee2oMDELHtp8ED',
                  'event_callback': callback
              });
              return false;
            }
          `}
          </script>
        )}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-EWDRR6G7YJ"
          data-ot-ignore
        />
        <script data-ot-ignore>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag() {dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-EWDRR6G7YJ');
          `}
        </script>
      </Helmet>
    </>
  );
};
export default SEO;

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
        schemaOrgs {
          _context
          _type
          address {
            _type
            addressCountry
            addressLocality
            addressRegion
            postalCode
            streetAddress
          }
          description
          foundingDate
          logo
          member {
            _type
            jobTitle
            name
          }
          name
          sameAs
          url
          publisher {
            _type
            name
            logo {
              _type
              height
              width
              url
            }
            address {
              _type
              addressCountry
              addressLocality
              postalCode
              addressRegion
              streetAddress
            }
          }
        }
      }
    }
  }
`;
